import React, { useState } from "react";

function FaucetCreateAccountButton() {
  const [data, setData] = useState("");

  const handleClick = () => {
    fetch(`https://pdsapi.dase.io:8081/api/v37/users/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    })
      .then((response) => {
        console.log(response);
        return response.json();
      })
      .then((data) => {
        setData(JSON.stringify(data, null, 2));
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <>
      <h1>Create Account</h1>
      <div class="button is-primary" onClick={handleClick}>
        Create new account
      </div>
      {data && (
        <div>
          <pre>{data}</pre>
        </div>
      )}
    </>
  );
}

export default FaucetCreateAccountButton;
